<template>
  <div>
    <shifts-counter-view :isManagementEvaluation="isManagementEvaluation"
                         :shifts-data="connectedShiftsData"/>
  </div>
</template>

<script>
  import ShiftsCounterView from '@/components/shifts-counter/ShiftsCounterView';

  export default {
    name: 'ShiftsCounter',
    components: { ShiftsCounterView },
    props: {
      beamlines: {
        type: Object,
        required: true,
      },
      callData: {
        type: Object,
        required: true,
      },
      infrastructure: {
        type: String,
        required: true,
      },
      proposals: {
        type: Array,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      clearShiftsData() {
        const options = JSON.parse(JSON.stringify(this.callData));
        Object.keys(options).forEach((el) => {
          options[el].counter = 0;
          options[el].counterReserve = 0;
        });
        this.proposals.forEach((el) => {
          const env = el.general.end_station || 'CRYOEM';
          if (this.isManagementEvaluation) {
            if (this.hasProperty(el, 'management_evaluation')) {
              const { acceptance_mark, number_of_shifts } = el.management_evaluation;
              const shifts = Number(number_of_shifts);
              // eslint-disable-next-line camelcase
              const isApproved = acceptance_mark === 'approved';
              if (shifts && isApproved) {
                if (options[env]) {
                  options[env].counter += shifts;
                }
              }
              // eslint-disable-next-line camelcase
              const isReserve = acceptance_mark === 'reserve';
              if (shifts && isReserve) {
                if (options[env]) {
                  options[env].counterReserve += shifts;
                }
              }
            }
          } else if (this.hasProperty(el, 'final_grade')) {
            const {
              states = {},
              acceptance_mark,
              number_of_shifts,
            } = el.final_grade;
            const shifts = Number(number_of_shifts);
            // eslint-disable-next-line camelcase
            const isApproved = acceptance_mark === 'approved';
            // eslint-disable-next-line camelcase
            const isSubmittedBeforeAcceptanceMarkImplemented = states.name === 'submitted' && acceptance_mark === '';
            if (shifts && (isApproved || isSubmittedBeforeAcceptanceMarkImplemented)) {
              if (options[env]) {
                options[env].counter += shifts;
              }
            }
            // eslint-disable-next-line camelcase
            const isReserve = acceptance_mark === 'reserve';
            if (shifts && isReserve) {
              if (options[env]) {
                options[env].counterReserve += shifts;
              }
            }
          }
        });
        return options;
      },
      connectedShiftsData() {
        if (this.infrastructure === 'synchrotron') {
          return this.fillConnectedShifts();
        }
        return this.clearShiftsData;
      },
    },
    watch: {
      connectedShiftsData() {
        this.$emit('input', this.connectedShiftsData);
      },
    },
    methods: {
      fillConnectedShifts() {
        let options = JSON.parse(JSON.stringify(this.beamlines));
        Object.entries(options).forEach(([key, value]) => {
          if (value.every((el) => Object.keys(this.clearShiftsData).includes(el))) {
            options = this.fillCounterOfConnectedBeamlines(key, value, options);
          } else if (value.length > 1) {
            options = this.fillCounterNotEveryBeamlineParticipateCall(key, value, options);
          } else {
            delete options[key];
          }
        });
        return options;
      },
      fillCounterNotEveryBeamlineParticipateCall(key, value, options) {
        const optionsCopy = JSON.parse(JSON.stringify(options));
        delete optionsCopy[key];
        value.forEach((el) => {
          if (this.clearShiftsData[el]) {
            optionsCopy[el] = this.clearShiftsData[el];
          }
        });
        return optionsCopy;
      },
      fillCounterOfConnectedBeamlines(key, value, options) {
        const tempOption = {
          counter: 0,
          counterReserve: 0,
          shifts: 0,
          shiftsManagement: 0,
          shiftsReserve: 0,
          // eslint-disable-next-line camelcase
          end_stations: {},
        };
        value.forEach((el) => {
          if (this.clearShiftsData[el]) {
            tempOption.counter += this.clearShiftsData[el].counter;
            tempOption.counterReserve += this.clearShiftsData[el].counterReserve;
            tempOption.shifts += this.clearShiftsData[el].shifts;
            tempOption.shiftsManagement += this.clearShiftsData[el].shiftsManagement;
            tempOption.shiftsReserve += this.clearShiftsData[el].shiftsReserve;
            tempOption.end_stations[el] = {
              shifts: this.clearShiftsData[el].counter,
              shiftsReserve: this.clearShiftsData[el].counterReserve,
            };
          }
        });
        return {
          ...options,
          [key]: tempOption,
        };
      },
    },
  };
</script>

<style lang="scss"
       scoped>

</style>
